/* eslint-disable
    func-names,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const ClientOverviewDetailsCtrl = function (
  $scope,
  Client,
  ClientInfo,
  Address,
  AddOnCollection,
  LedgerCollection,
  NotificationsService,
) {
  this.client = new Client(this.clientId);
  this.clientVM = this.client.$viewModel();
  this.info = new ClientInfo(this.clientId);
  this.ledgers = new LedgerCollection(this.clientId);
  this.addOns = new AddOnCollection(this.clientId);

  this.maxCharacters = 1000;
  this.characterCountDanger = 100;
  let charactersLeft = this.maxCharacters;
  this.getCharactersLeft = () => charactersLeft;

  this.numAccounts = () => {
    const accountsOnly = _.filter(this.ledgers.getAccounts(), account => !account.isAddOn);
    return accountsOnly.length;
  };

  this.numAddOns = () => this.ledgers.getAddOnLedgers().length + this.addOns.data.length;

  this.resetNotes = () => {
    this.clientVM.$reset();
    return this.notesForm.$setPristine();
  };

  this.saveNotes = () =>
    NotificationsService.loader({
      resolve: this.client.$put(this.clientVM.$data()),
      loadingText: 'Updating notes...',
      successText: 'Notes saved.',
      failureText: 'Your notes could not be updated.',
    }).then(() => this.resetNotes());

  this.updateCharactersLeft = function () {
    if (this.clientVM.notes) {
      return (charactersLeft = this.maxCharacters - this.clientVM.notes.length);
    }
  };

  $scope.$watch('vm.clientVM.notes', notes => this.updateCharactersLeft());
};

module.exports = ClientOverviewDetailsCtrl;
